import { Button, Text } from "@growtherapy/sprout-ui";
import {
  PRE_SESSION_PROMPT_CTA_INTRO_TEXT,
  REFLECTION_TOPICS_CTA_BUTTON_TEXT,
  VIBES_CTA_BUTTON_TEXT,
} from "./lang";

import { useSetAtom } from "jotai";
import { useBackgroundMusicPlayback } from "../background-action/useBackgroundMusicPlayback";
import {
  preSessionVibesOpenAtom,
  VisitorDrawerState,
  visitorDrawerStateAtom,
} from "../../state";

export function ReflectionTopicsCta({
  openPreSessionVibes,
  openReflectionTopicsDrawer,
}: {
  openPreSessionVibes: () => void;
  openReflectionTopicsDrawer: () => void;
}) {
  return (
    <>
      <Text
        data-testid="pre-session-prompt-reflection-topics"
        className="font-medium"
      >
        {PRE_SESSION_PROMPT_CTA_INTRO_TEXT}
      </Text>
      <Button
        className="flex gap-4 justify-center items-center w-full"
        onClick={openReflectionTopicsDrawer}
      >
        {REFLECTION_TOPICS_CTA_BUTTON_TEXT}
      </Button>
      <Button onClick={openPreSessionVibes} use="link">
        Or {VIBES_CTA_BUTTON_TEXT.toLowerCase()}
      </Button>
    </>
  );
}

export function ReflectionTopicsCtaWrapper() {
  const setPreSessionVibesOpen = useSetAtom(preSessionVibesOpenAtom);
  const setDrawerState = useSetAtom(visitorDrawerStateAtom);
  const { handlePlay } = useBackgroundMusicPlayback();
  const openPreSessionVibes = () => {
    setDrawerState(null);
    setPreSessionVibesOpen(true);
    handlePlay();
  };
  const openReflectionTopicsDrawer = () => {
    setDrawerState(VisitorDrawerState.REFLECTION_TOPICS);
  };
  return (
    <ReflectionTopicsCta
      openPreSessionVibes={openPreSessionVibes}
      openReflectionTopicsDrawer={openReflectionTopicsDrawer}
    />
  );
}
